import styled from 'styled-components';
import { Typography } from '@mui/material';
import Box from 'common/components/Box';

export const ShortDescriptionContainer = styled.div`
  width: 100%;
`;
export const TitleContainer = styled.div`
  width: 100%;
`;
export const CustomBoxContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

export const CustomLeftBoxTable = styled(Box)`
  width: 18vw;
  top: 140px;
  @media (max-width: 986px) {
    display: none;
  }
`;

export const CustomBoxTocContainer = styled(Box)`
  border: 1px solid #817a99;
  border-radius: 8px;
  overflow: auto;
  padding: 16px;
`;

export const CustomBoxTypography = styled(Typography)`
  fontsize: 24px;
  margin-bottom: 8px;
  display: block;
`;

export const CustomBoxContentTableMobile = styled(Box)`
  top: 140px;
  display: none;
  @media (max-width: 986px) {
    display: block;
  }
`;
